module.exports = __webpack_public_path__ + "images/category_lp/pc/past_jisseki_1e9c08512b19bd115193c02801e58585.jpg";